// Errori di emissione card virtuale in modalità Range (registrazione).
// 416 = range esaurito, 404 = nessun range attivo.
export type CardErrorType = "CARD_RANGE_EXHAUSTED" | "CARD_RANGE_NOT_FOUND";

export const CARD_ERROR_MESSAGES: Record<CardErrorType, { title: string; text: string }> = {
  CARD_RANGE_EXHAUSTED: {
    title: "Numeri di card virtuali temporaneamente esauriti",
    text: "Mostra questo messaggio al tuo Farmacista.",
  },
  CARD_RANGE_NOT_FOUND: {
    title: "Numeri di card virtuali temporaneamente non disponibili",
    text: "Mostra questo messaggio al tuo Farmacista.",
  },
};
